// Pure resolver shared by the browser and build validation. Public values only.
const PRODUCTION_API_HOST = 'api.mcmullenbrownecrm.com';

function resolveEnvironment(input) {
  const appEnv = input.REACT_APP_APP_ENV || (['development', 'test'].includes(input.NODE_ENV) ? 'local' : '');
  if (!['local', 'staging', 'production'].includes(appEnv)) {
    throw new Error('Set REACT_APP_APP_ENV to local, staging or production.');
  }
  const apiUrl = input.REACT_APP_API_URL || (appEnv === 'local' ? 'http://localhost:3001/api/v1' : '');
  let url;
  try { url = new URL(apiUrl); } catch { throw new Error('REACT_APP_API_URL must be an absolute API URL.'); }
  if (url.username || url.password || url.search || url.hash || url.pathname.replace(/\/$/, '') !== '/api/v1') {
    throw new Error('REACT_APP_API_URL must end in /api/v1 and contain no credentials, query or fragment.');
  }
  if (url.hostname.endsWith('.')) throw new Error('API hostnames must not end in a dot.');
  const productionHost = [PRODUCTION_API_HOST, 'mcmullen-browne-crm.onrender.com', 'mcmullen-browne-crm-1.onrender.com', 'mcmullenbrownecrm.com', 'www.mcmullenbrownecrm.com'].includes(url.hostname);
  const loopback = ['localhost', '127.0.0.1', '[::1]'].includes(url.hostname);
  if (appEnv === 'local' && (!loopback || !['http:', 'https:'].includes(url.protocol))) {
    throw new Error('Local builds must use a loopback API. Use staging for a remote test API.');
  }
  if (appEnv !== 'local' && url.protocol !== 'https:') {
    throw new Error('Hosted environments require HTTPS.');
  }
  if (appEnv === 'staging' && (productionHost || loopback)) {
    throw new Error('Staging must use a separate hosted API, never production or loopback.');
  }
  if (appEnv === 'production' && url.hostname !== PRODUCTION_API_HOST) {
    throw new Error('Production must target the registered production API.');
  }
  return Object.freeze({ appEnv, apiUrl: url.href.replace(/\/$/, '') });
}

module.exports = { resolveEnvironment };
